const arrayHasData = (data?: any[]) => {
  return !!(data && data.length > 0);
};

export { arrayHasData };
